"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permutationsDependencies = void 0;
var _dependenciesFactorialGenerated = require("./dependenciesFactorial.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var permutationsDependencies = exports.permutationsDependencies = {
  factorialDependencies: _dependenciesFactorialGenerated.factorialDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createPermutations: _factoriesAny.createPermutations
};